import { Div, Heading, Img, Section, Text } from "../../styles/base.style";
import { TrustItem } from "../../pages/Home/home.style";
import { memo } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function SectionTrusted({text_editor}) {
    let {trusted_ss, testimonial} = text_editor
    let {
        customer_description,
        happy_customer,
        number_customer,
        number_review,
        review_description,
        reviews_star,
        trusted_heading
    } = trusted_ss
    return (
        <Section id="trusted-ss" p="95px 0 110px">
            <Div className="container">
                <Div className="row">
                    <Div className="col-md-6" mb={['30px', '30px', 0]}>
                        <Heading fontSize="30px" m="0 0 10px 0">{trusted_heading}</Heading>
                        {testimonial.length > 0 && (
                            <Swiper
                                spaceBetween={30}
                                slidesPerView={1}
                                navigation={false}
                                autoplay
                                loop={true}
                                pagination={{clickable: true}}
                                modules={[Navigation, Pagination, Autoplay]}
                            >
                                { testimonial.map((e, i) => {
                                    return (
                                        <SwiperSlide key={'test-' + i}>
                                            <Text ml="50px">{e.content}</Text>
                                            <Div display="flex" alignItems="center">
                                                <Img mr="18px" borderRadius="50%" src={e.avatar} alt="avatar" />
                                                <Div>
                                                    <Heading className="text-uppercase" m="0" fontSize="20p">{e.name}</Heading>
                                                    <Text className="text-uppercase" m="0" fontSize="14px">{e.position}</Text>
                                                </Div>
                                            </Div>
                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>
                        )}
                    </Div>
                    <Div className="col-md-3" mb={['10px', '10px', 0]}>
                        <TrustItem>
                            <Heading>{number_customer}<Text as="span" fontWeight="300">+</Text></Heading>
                            <Heading as="h4">{happy_customer}</Heading>
                            <Text>{customer_description}</Text>
                        </TrustItem>
                    </Div>
                    <Div className="col-md-3">
                        <TrustItem>
                            <Heading>{number_review}<Text as="span" fontWeight="300">+</Text></Heading>
                            <Heading as="h4">{reviews_star}</Heading>
                            <Text>{review_description}</Text>
                        </TrustItem>
                    </Div>
                </Div>
            </Div>
        </Section>
    )
}

export default  memo(SectionTrusted);
